<div *ngIf="!isWizard">
  <div class="sub-header">{{'onboarding.update_shopify_config' | translate}}</div>

  <div class="row margin-top-8">
    <div class="col-md-4 label">
      {{'onboarding.select_location' | translate}}:
      <span class="help fa hubtiger-tooltip" pTooltip="{{'onboarding.select_shop_info' | translate}}"></span>
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon"><i class="fa fa-home"></i></span>
        <p-dropdown [options]="locations" [(ngModel)]="config.LocationID"
                    placeholder="{{'onboarding.select_shop' | translate}}">
        </p-dropdown>
      </div>
    </div>
  </div>

  <div class="row margin-top-8">
    <div class="col-md-4 label">
      Use Draft Orders:
      <!--{{'onboarding.select_location' | translate}}:-->
      <span class="help fa hubtiger-tooltip"
            pTooltip="Send to Shopify as a draft order rather than as an order"></span>
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup pull-right">
        <p-inputSwitch [(ngModel)]="config.UseDraftOrders"></p-inputSwitch>
      </div>
    </div>
  </div>
  <div class="row margin-top-8">
    <div class="col-md-8 label"></div>
    <div class="col-md-4">
      <button type="submit" class="iso-round-button" style="float: right;"
              (click)="updateConfig()"
              [disabled]="busy || !config.LocationID">{{ busy ? ('onboarding.button.please_wait' | translate) : (config.LocationID) ? ('onboarding.button.update_config' | translate) : ('onboarding.button.set_config' | translate)}}</button>
    </div>
  </div>

  <div class="row margin-top-8">
    <div class="col-md-12 label">
      {{'onboarding.select_tax' | translate}}:
    </div>
  </div>

  <div class="row margin-top-8" *ngIf="taxesUsed !== undefined">

    <p-table [value]="taxesUsed" class="margin-top-8">
      <ng-template pTemplate="header">
        <tr>
          <th colspan="2">{{'bikeshop.rentals.category.category' | translate}}</th>
          <th>%</th>
          <th style="width:60px;"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData>
        <tr>
          <td pEditableColumn colspan="2">
            <p-cellEditor>
              <ng-template pTemplate="input">
                {{rowData.category}}
                <!--<p-dropdown [options]="brands" [style]="{'width':'100%'}" [(ngModel)]="rowData.category"></p-dropdown>-->
              </ng-template>
              <ng-template pTemplate="output">
                {{rowData.category}}
              </ng-template>
            </p-cellEditor>
          </td>

          <td pEditableColumn>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="number" [(ngModel)]="rowData.taxRate">
              </ng-template>
              <ng-template pTemplate="output">
                {{rowData.taxRate}}
              </ng-template>
            </p-cellEditor>
          </td>

          <td style="width:60px">
            <button pButton type="button" icon="pi pi-trash" class="p-button-danger"
                    style="margin-right: .5em; background-color: #e91224 !important; border: 1px solid #e91224 !important;"
                    (click)="removeCustomTaxRate(rowData.category)"></button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="footer">
        <tr class="add-tax-item">
          <td pEditableColumn style="border: none" colspan="2">
            <p-dropdown [options]="categories" [style]="{'width':'100%'}"
                        [(ngModel)]="category"
                        (onFocus)="openModal($event)"
            ></p-dropdown>
          </td>

          <td pEditableColumn style="border: none">

            <input pInputText type="number" [(ngModel)]="taxRate">
          </td>
          <td style="text-align: right; border: none; width: 60px;">
            <button pButton type="button" icon="pi pi-plus" class="p-button-danger"
                    style="margin-right: .5em" (click)="addCustomTaxRate()"
                    [disabled]="category == ''"></button>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <div class="row col-md-12 margin-top-8">
      <div class="col-md-8 label">{{ 'bikeshop.shop_setup.card_description.pos_products' | translate }}</div>
      <div class="col-md-4" style="text-align: center">
        <button pButton type="submit" class="p-button-raised full-width" icon="pi pi-refresh"
                (click)="syncProducts()"></button>
      </div>
    </div>
  </div>


</div>

<!--Bit of a stuff up because of the dark UI in the wizard and light wizard in the portal, this is a shared compnent :(-->
<div *ngIf="isWizard">
  <div class="row margin-top-32 help-row">
    <div class="col-md-12">
      <div class="p-float-label">
        <p-dropdown [options]="locations" [(ngModel)]="config.LocationID"
                    placeholder="{{'onboarding.select_shop' | translate}}">
        </p-dropdown>
        <label>{{'onboarding.select_location' | translate}}</label>
      </div>
    </div>
    <span class="help fa hubtiger-tooltip" pTooltip="{{'onboarding.select_shop_info' | translate}}"></span>
  </div>
  <div class="row margin-top-32 help-row">
    <div class="col-md-4 label">
      Use Draft Orders:
      <!--{{'onboarding.select_location' | translate}}:-->
      <span class="help fa hubtiger-tooltip"
            pTooltip="Send to Shopify as a draft order rather than as an order"></span>
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup pull-right">
        <p-inputSwitch [(ngModel)]="config.UseDraftOrders"></p-inputSwitch>
      </div>
    </div>
    <span class="help fa hubtiger-tooltip" pTooltip="{{'onboarding.select_shop_info' | translate}}"></span>
  </div>
  <div class="row margin-top-32">
    <div class="col-md-12">
      <button type="submit" class="iso-round-button" style="float: right;"
              (click)="updateConfig()"
              [disabled]="busy || !config.LocationID">{{ busy ? ('onboarding.button.please_wait' | translate) : (config.LocationID) ? ('onboarding.button.update_config' | translate) : ('onboarding.button.set_config' | translate)}}</button>
    </div>
  </div>
</div>

<p-dialog [(visible)]="isModalOpen" [modal]="true" [closable]="true" header="Select a Category" [style]="{ height: '25rem', width: '25rem' }">
  <div class="p-fluid">
    <div class="p-field">
      <label for="category">Category</label>
      <div *ngIf="checkValidCategories()">
        <p-dropdown id="category" [options]="categories" [(ngModel)]="category" (onChange)="closeModal()" placeholder="Select a category"></p-dropdown>
      </div>

      <div *ngIf="!checkValidCategories()">
        <p-dropdown [disabled]="true" id="category" [options]="categories" [(ngModel)]="category" placeholder="No unused categories"></p-dropdown>
      </div>

    </div>
<!--    <div class="modal-footer">-->
<!--      <button  class="iso-round-button pr-4" (click)="closeModal()">Cancel</button>-->
<!--      <button  class="iso-round-button iso-light" (click)="confirmSelection()">Confirm</button>-->
<!--    </div>-->
  </div>
</p-dialog>

<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>
